<div class="table-view-table" [ngClass]="{ 'three-fixed-columns': showConfidentialityComponent }">
  <ng-container *ngIf="allColumns?.length && reportRecordData?.length; else noRecords">
    <p-table [columns]="allColumns" [value]="reportRecordData" [reorderableColumns]="true">
      <ng-template pTemplate="header" let-columns>
        <tr class="table-view-headers">
          <th scope="col">{{ actionHeader }}</th>
          <!-- Confidentiality header -->
          <th scope="col" *ngIf="showConfidentialityComponent" class="confidentiality-header">
            {{ 'template.reportViewState' | xTranslate | uppercase }}
          </th>
          <ng-container *ngFor="let col of columns">
            <th scope="col" pReorderableColumn (dragend)="reorderColumns(columns)">
              {{ col.header | uppercase }}
            </th>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-recordCatalog let-columns="columns" let-i="rowIndex">
        <tr [pReorderableRow]="i" (dragstart)="dragStartColumn(i)" (dragend)="dropColumn(i)" draggable="true">
          <td class="sno">
            <!-- NOTE: this i is being used to render font-awesome icon, but might be caught by sonarqube. Resolve it as "won't fix" -->
            <i class="fa fa-arrows move-record" pReorderableRowHandle></i>
            <mat-icon
              class="green-close"
              color="y-icon"
              svgIcon="close-icon-grey"
              (click)="removeRecord.emit(recordCatalog)"
            ></mat-icon>
            <ng-container
              [ngTemplateOutlet]="templateProjectionMap | selectTemplateOutlet: 'miq-goes-to-record'"
              [ngTemplateOutletContext]="{
                classes: '',
                urlParams: recordCatalog | dataViewRoute: reportData.entity,
                content: goToIcon,
                navigateOptions: {
                  type: 'static',
                  ids: reportRecordData | extractRecordsFromReportRecordFn | pickDataFrom: 'data.entity.id',
                  entity: reportData.entity,
                },
              }"
            ></ng-container>
            <ng-template #goToIcon>
              <mat-icon class="print-hidden open-in-new-tab-icon" color="y-icon" svgIcon="new-window"></mat-icon>
            </ng-template>
          </td>
          <!-- Confidentiality component -->
          <td *ngIf="showConfidentialityComponent">
            <div class="confidentiality-container">
              <ng-container
                [ngTemplateOutlet]="templateProjectionMap | selectTemplateOutlet: 'miq-confidentiality-control-tmpl'"
                [ngTemplateOutletContext]="{ reportItem: recordCatalog, displayLabel: true, isDataOnly: true }"
              ></ng-container>
            </div>
          </td>

          <td *ngFor="let col of columns" class="data-columns">
            <span
              class="table-data-cells"
              [ngClass]="{ clickable: col?.isEditable }"
              (click)="emitEditableFields($event, col, recordCatalog)"
              >{{ recordCatalog | dataViewFormatter: col }}
            </span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </ng-container>
  <ng-template #noRecords>
    <div class="no-records" l10nTranslate>template.noData</div>
  </ng-template>
</div>
